import React, { useState } from 'react';
import { Checkbox, FormControlLabel } from '@material-ui/core';
import EchoDialog from 'components/EchoDialog';
import { ITenant } from 'interfaces/tenant';
import { IEchoEdge } from 'interfaces/echo-edge';
import { DeleteEdgeModel } from 'models/edge/delete-edge-model';
import { MutationsStatic } from 'graphql/mutations-static';
import { GraphQLHelper } from 'utilities/graphql-helper';

interface Props {
  edge: IEchoEdge | undefined,
  tenant: ITenant,
  onDeleted: () => void,
  onCancel: () => void
}

const EdgeDelete: React.FC<Props> = (props) => {
  const [errorDeleting, setErrorDeleting] = useState('');
  const [infoDeleting, setInfoDeleting] = useState('');
  const [successDeleting, setSuccessDeleting] = useState('');
  const [drainEdge, setDrainEdge] = useState(true);
  const [isLoading, setIsLoading] = useState(false);

  const clearState = () => {
    setErrorDeleting('');
    setInfoDeleting('');
    setSuccessDeleting('');
  }

  const onDeleteEdge = async () => {
    try {
      setIsLoading(true);
      clearState();
      const params = {
        source: props.edge?.source,
        target: props.edge?.target,
        tenant: props.tenant.name,
      }
      const query = MutationsStatic.deleteEdge(drainEdge);
      const p = await GraphQLHelper.execute<DeleteEdgeModel>(query, params, DeleteEdgeModel);
       if (!p.error) {
      const deletedEdge = p.result as DeleteEdgeModel;
      console.log(deletedEdge);
      props.onDeleted();
      setSuccessDeleting(`Edge deleted.`);
    } else {
      setErrorDeleting(p.errorMessage);
    }
    } catch (err) {
      console.log(err);
      setErrorDeleting(JSON.stringify(err));
    } finally {
      setIsLoading(false);
    }
  }

  return (
    <EchoDialog
      open={true}
      title={`Delete edge from "${props.edge?.source}" to "${props.edge?.target}"`}
      errorMessage={errorDeleting}
      infoMessage={infoDeleting}
      successMessage={successDeleting}
      confirmDialog={true}
      onCancel={props.onCancel}
      onOk={props.onDeleted}
      onSave={() => onDeleteEdge()}
      contentText=""
      isValid={true}
      spinner={isLoading}
    >
      <FormControlLabel
        control={
          <Checkbox
            checked={drainEdge}
            onChange={(): void => { setDrainEdge(!drainEdge); }}
            name="checkedB"
            color="primary"
          />
        }
        disabled={((successDeleting && successDeleting.length > 0) ? true : false) || isLoading}
        label="Drain Edge"
      />
    </EchoDialog>
  )
}

export default EdgeDelete;